// extracted by mini-css-extract-plugin
module.exports = {"formBox":"HomeBookSection_formBox__2XqWC","contentBox":"HomeBookSection_contentBox__nCbxi","mainWrapper":"HomeBookSection_mainWrapper__7mEpu"};